// Copyright (c) 2024 - Present. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { SvgIcon, SvgIconProps } from '@mui/material';

function parsePx(value: number | string): number {
  if (typeof value === 'string') {
    return parseFloat(value.replace('px', ''));
  }
  return value;
}

/**
 * An SVG icon component that renders the NetSuite logo.
 */
export function NetSuiteIcon(props: SvgIconProps) {
  const { width, height, ...extra } = props;
  // If color is set, SVGIcon will have the correct color so the fill should use currentColor. If missing, use the default NetSuite colors
  const useColor = props.color ? 'currentColor' : null;
  const useWidth = width ? parsePx(width) : 32;
  const useHeight = height ? parsePx(height) : useWidth;
  return (
    <SvgIcon {...extra}>
      <svg
        width={useWidth + 'px'}
        height={useHeight + 'px'}
        viewBox="0 0.2 150 150"
        xmlns="http://www.w3.org/2000/svg"
        role="img"
      >
        <path d="M0 .2h150v150H0z" fill="none" />
        <path
          d="M20.1 47.7h23.7V104h11.8v22H20.1zm109.7 51.8h-23.7V43.2H94.3v-22h35.5z"
          fill={useColor ?? '#baccdb'}
        />
        <path
          d="M14.6 15.8h74.9v64.3L60.7 43H14.6zm120.6 115.7H60.3V67.2l28.8 37.1h46.1"
          fill={useColor ?? '#125580'}
        />
      </svg>
    </SvgIcon>
  );
}
